var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconManufacturer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 43.7002C33.7635 43.7002 40.4624 37.0013 40.4624 28.7378C40.4624 20.4743 33.7635 13.7754 25.5 13.7754C17.2365 13.7754 10.5376 20.4743 10.5376 28.7378C10.5376 37.0013 17.2365 43.7002 25.5 43.7002Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8058 16.2922C31.9191 15.0308 29.7079 16.648 29.7079 18.9175C29.7079 19.1768 29.6049 19.4255 29.4215 19.6088L25.7864 23.244C25.603 23.4274 25.5 23.6761 25.5 23.9354V26.0838C25.5 26.6238 25.9378 27.0616 26.4779 27.0616H32.1902C32.4046 27.0616 32.613 27.1321 32.7835 27.2621L36.7286 30.2731C38.2585 31.4408 40.4624 30.6631 40.4624 28.7385C40.4624 23.5481 37.8193 18.9755 33.8058 16.2922Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2804 33.2297C20.0078 33.2297 18.9762 32.1981 18.9762 30.9255V28.9593C18.9762 28.4193 18.5383 27.9814 17.9983 27.9814H11.3134C10.8895 27.9814 10.5376 28.314 10.5376 28.738C10.5376 34.8396 14.1899 40.0883 19.4277 42.4169C22.5824 43.8194 25.5 40.9016 25.5 37.4492C25.5 37.1899 25.397 36.9412 25.2137 36.7578L21.9719 33.516C21.7884 33.3327 21.5397 33.2297 21.2804 33.2297Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1507 7.47585L25.7842 4.23787L28.1507 1",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7583 4.27051C39.7046 4.9254 50.0002 15.6299 50.0002 28.739C50.0002 39.7082 42.7916 48.9937 32.8531 52.1166",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2989 53.2102C11.3258 52.5839 1 41.8673 1 28.7389C1 17.7698 8.20866 8.48421 18.1472 5.36133",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8496 50.001L25.2161 53.239L22.8496 56.4768",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManufacturer);
export default __webpack_public_path__ + "static/media/icon-manufacturer.2fdf2882f810fca7a075c238c3fd7b94.svg";
export { ForwardRef as ReactComponent };